<template>
  <div class="banner">
    <el-carousel :height="getHeight()" arrow="never" :interval="5000">
      <el-carousel-item v-for="(item, index) in bannerImg" :key="`banner${index}`">
        <img :src="item" style="height: 100%; width: 100%"/>
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import banner from '@/assets/images/gateway/bannerIIII.png'
import bannerI from '@/assets/images/gateway/bannerIII.png' 
export default {
  data () {
    return {
      bannerImg: [
        bannerI,
        banner
      ]
    }
  },
  methods: {
    getHeight () {
      return `${document.documentElement.clientHeight - this.$remToPx(2.1)}px`
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-carousel__button {
  width: 0.3rem;
  height: 0.05rem;
  border-radius: 0.02rem;
}
</style>